import React from 'react'
import { IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { DiscountRuleRow } from '../interfaces'

export const toTableRowItems = (list: DiscountRuleRow[]) =>
  list.map(r => ({
    ...r,
    effectiveMonthLabel: `${String(r.month).padStart(2, '0')}/${r.year}`,
  }))

export const columns = ({
  onEdit,
  onDelete,
  isLoading,
  canMutateRow
}: {
  onEdit: (row: DiscountRuleRow) => void
  onDelete: (row: DiscountRuleRow) => void
  isLoading?: boolean
  canMutateRow?: (row: DiscountRuleRow) => boolean
}) => [
  {
    title: 'Lună',
    field: 'effectiveMonthLabel',
    align: 'left',
    type: 'string',
    width: '90px',
  },
  {
    title: 'Cashback (%)',
    field: 'cashbackPercent',
    align: 'left',
    type: 'string',
    width: '110px',
    render: (row: any) => `${row.cashbackPercent}%`,
  },
  {
    title: 'Tranz./zi',
    field: 'transactionsPerDay',
    align: 'left',
    type: 'string',
    width: '90px',
  },
  {
    title: 'Min/zi',
    field: 'minimumAmountDay',
    align: 'left',
    type: 'string',
    width: '110px',
    render: (row: any) => `${row.minimumAmountDay} RON`,
  },
  {
    title: 'Max/zi',
    field: 'maximumAmountDay',
    align: 'left',
    type: 'string',
    width: '110px',
    render: (row: any) => `${row.maximumAmountDay} RON`,
  },
  {
    title: 'Min/lună',
    field: 'minimumAmountMonth',
    align: 'left',
    type: 'string',
    width: '120px',
    render: (row: any) => `${row.minimumAmountMonth} RON`,
  },
  {
    title: 'Max/lună',
    field: 'maximumAmountMonth',
    align: 'left',
    type: 'string',
    width: '120px',
    render: (row: any) => `${row.maximumAmountMonth} RON`,
  },
  {
    title: '',
    field: 'actions',
    align: 'center',
    type: 'string',
    width: '80px',
    render: (row: DiscountRuleRow) => (
      <div style={{ display: 'flex', gap: 8 }}>
        { canMutateRow(row) && (
         <>
           <IconButton size="small" onClick={() => onEdit(row)} aria-label="Editează">
             <EditIcon fontSize="small" />
           </IconButton>
           <IconButton size="small" onClick={() => onDelete(row)} aria-label="Șterge" disabled={isLoading}>
             <DeleteIcon fontSize="small" />
           </IconButton>
         </>
        )}
      </div>
    ),
  },
]

export const toolbarActions = ({
 isEditing,
 onCancelEdit,
}: {
  isEditing: boolean
  onCancelEdit?: () => void
}) => {
  let actions: any[] = []

  if (isEditing && onCancelEdit) {
    actions = [
      ...actions,
      {
        label: 'Anulează editarea',
        onClick: onCancelEdit,
      },
    ]
  }

  return actions
}
